import React from 'react';

import { Box, Flex, Image } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const EmptySummaryCard = ({
  Icon,
  heading = '',
  illustrationSrc,
  description,
  descriptionComp = null,
  CTAComp = () => {},
  redirectUrl = '',
  onClick = () => {},
  ...props
}) => {
  const Wrapper = redirectUrl?.length > 0 ? Link : Box;
  return (
    <PaperWithShadow px={3} py={2} {...props}>
      <Flex flexDir="column">
        <Flex alignItems="center" gap={2} px={2} pt={1} pb={3} borderBottom="1px solid" borderColor="border.CFD7DF">
          {Icon && <Icon fill="transparent" boxSize="24px" color="icon.g2" />}
          <TextBodyMedium bold color="text.g1">
            {heading}
          </TextBodyMedium>
        </Flex>
        <Wrapper
          to={redirectUrl}
          style={{ textDecoration: 'none', cursor: redirectUrl ? 'pointer' : 'default' }}
          onClick={onClick}
        >
          <Flex p="12px" alignItems="center">
            <Box
              sx={{
                height: '80px',
                width: '135px',
                marginRight: '16px',
              }}
            >
              <Image w="100%" h="100%" alt="" src={illustrationSrc} />
            </Box>
            {descriptionComp ? descriptionComp() : <TextBodyMedium w="75%">{description}</TextBodyMedium>}
          </Flex>
          <div style={{ marginLeft: '12px' }}>{CTAComp()}</div>
        </Wrapper>
      </Flex>
    </PaperWithShadow>
  );
};

export { EmptySummaryCard };
